import { Heading, Link, ListItem, OrderedList, Text, UnorderedList } from '@chakra-ui/react'
import type { defaults } from 'chakra-ui-markdown-renderer'
import ChakraUIRenderer from 'chakra-ui-markdown-renderer'
import NextLink from 'next/link'
import ReactMarkdown from 'react-markdown'
import rehypeSlug from 'rehype-slug'
import remarkGfm from 'remark-gfm'

// For customization, see https://github.com/remarkjs/react-markdown#appendix-b-components
type ChakraUiMarkdownRendererType = typeof defaults

const txtTheme: ChakraUiMarkdownRendererType = {
  a: ({ href, children }) => {
    if (!href) return null
    return (
      <Link
        as={NextLink}
        href={href}
        color="txtBlue"
        textDecoration="underline"
        _hover={{ textDecoration: 'none' }}
      >
        {children ?? href}
      </Link>
    )
  },
  p: ({ children }) => {
    return <Text fontSize="sm">{children}</Text>
  },
  h1: ({ children, id }) => {
    return (
      <Heading as="h1" size="xl" my={8} mb={4} id={id}>
        {children}
      </Heading>
    )
  },
  h2: ({ children, id }) => {
    return (
      <Heading as="h2" size="lg" my={8} mb={4} id={id}>
        {children}
      </Heading>
    )
  },
  h3: ({ children, id }) => {
    return (
      <Heading as="h3" size="md" my={4} mb={2} mt={4} id={id}>
        {children}
      </Heading>
    )
  },
  ul: ({ children }) => {
    return (
      <UnorderedList styleType="none" fontSize="sm">
        {children}
      </UnorderedList>
    )
  },
  ol: ({ children }) => {
    return <OrderedList fontSize="sm">{children}</OrderedList>
  },
  li: ({ children }) => {
    return <ListItem ml="2rem">{children}</ListItem>
  },
}

export function Markdown({ children }: { children: string }) {
  return (
    <ReactMarkdown
      components={ChakraUIRenderer(txtTheme)}
      skipHtml
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeSlug]}
    >
      {children}
    </ReactMarkdown>
  )
}
